/**
 * Complete-quote tour — /operator/complete-quote/:id
 *
 * This is the legacy "next steps" view: customer email + structured shipment,
 * then a grid of action buttons (request airline rates, agent rates, draft
 * comparison, shipper thread). The operator picks which path to take next.
 *
 * Anchors (verified in CompleteQuoteDetail.jsx):
 *   cq-email      OriginalEmailCard wrapper
 *   cq-shipment   CompleteShipmentDetails wrapper
 *   cq-actions    Next Steps action grid
 */

export const conversationTour = {
  id: "conversation",
  label: "Complete Quote — Next Steps",
  steps: [
    {
      target: "cq-email",
      title: "The original enquiry",
      description:
        "This card shows the customer's email — exactly what they sent, with attachments. Always start here: understand the ask before you take action.",
      placement: "right",
    },
    {
      target: "cq-shipment",
      title: "Structured shipment",
      description:
        "We've extracted the key details — origin, destination, packages, weights — into a clean card so you don't have to scan the email. Flag anything missing before quoting.",
      placement: "left",
    },
    {
      target: "cq-actions",
      title: "Pick your next step",
      description:
        "Four paths, each opens a focused workspace. Request Airline Rates is the usual starting point; the others cover agents, comparison drafts, and shipper contact.",
      bullets: [
        "Request Airline Rates — send carrier enquiries",
        "Agent Rates — check saved agent pricing",
        "Draft Comparison — stack options side-by-side",
        "Shipper Thread — message the shipper if email is known",
      ],
      placement: "top",
    },
  ],
};
